const routes = {
  admin: {
    auctionPayment: "Listing commission",
    documents: "Documents for verification",
    profile: "Profile",
    adverts: "Ads",
    profile_settings: "Profile settings",
    companies: "Companies",
    time_window: "Time windows",
    workers: "Employees",
    invoices: "Invoices",
    tenders: "Tenders",
    price: "Pricing",
    subscription: "Subscription",
    company: "Company",
    department: "Department",
    group_chat: "Group message",
    group_chats: "Group chats",
    chats: "Chats",
    chat: "Chat",
    raports: "Reports",
    add_worker: "Add employee",
    add_wroker_to_department: "Add employee to department",
    add_vehicle: "Add vehicle",
    add_documents: "Add documents",
    add_department: "Add department",
    factoring: "Factoring list",
    auctions: "Job marketplace",
    users: "Users",
    verificationPayments: "Verification transfers",
  },
  auth: {
    register: "Registration",
    login: "Login",
    forgot_password: "Forgot password",
    reset_password: "Reset password",
    verification: "Account verification",
    confirm_registration: "Registration confirmation",
  },
  not_found: "Page not found",
  user: {
    add_offer: "Add offer",
    add_driver: "Add driver",
    "pilot-offers": "Pilot marketplace",
    "pilot-offer-mine": "My pilot offers",
    "pilot-offer-adding": "Add free pilot offer",
    dashboard: "Dashboard",
    profile: "My profile",
    company: "Company",
    settings: "Settings",
    add_document: "Add document",
    add_worker: "Add employee",
    add_warehouse: "Add warehouse",
    add_department: "Add department",
    workers: "Employees",
    warehouses: "Warehouses",
    departments: "Departments",
    calendar: "Calendar",
    fill_calendar: "Fill in calendar",
    pick_calendar: "Select calendar",
    edit_day: "Edit day",
    add_user: "Add user",
    language: "Language",
    driver_departments: "Carrier list",
    department_details: "Department details",
    documents: "Document list",
    department_workers: "Department employees",
    warehouse_workers: "Warehouse employees",
    department_invite: "Department invitation",
    authorization: "Authorization",
    authorizations: "Authorizations",
    add_car: "Add car",
    cars: "Cars",
    insurances: "Insurances",
    add_monitary: "Notification",
    car_statuses: "Car statuses",
    accept_monitary: "Confirm notification",
    finish_monitary: "Finish notification",
    monitary_list: "Notification list",
    monitary_archive: "Notification archive",
    monitary_edit: "Edit notification",
    stock: "Job marketplace",
    add_auction: "Add order",
    wallet: "My wallet",
    payment_processing: "Payment processing",
    widgets_settings: "Widget settings",
    notifications: "Notifications",
    chat_list: "Messages",
    chat: "Chat",
    offers: "Assigned jobs",
    won_auctions: "Assigned transports",
    lost_auctions: "Unwon transports",
    canceled_transports: "Cancelled / lost transports",
    current_auctions: "Ongoing jobs",
    surcharges: "Current surcharges",
    my_auctions: "My jobs",
    auction_archive: "Job archive",
    edit_auction: "Edit auction",
    cancelled_auctions: "Cancelled jobs",
    contract_terms: "Contract terms",
    group_making: "Group creation",
    participants_list: "Participant list",
    added_driver_groups: "Created pilot groups",
    invoices: "Invoices",
    blocked_users: "Blocked users",
    factoring: "Factoring",
  },
};

export default routes;
